import {
  ArrowDownToLine,
  ArrowUpFromLine,
  BellRing,
  Banknote,
  Boxes,
  Building2,
  CalendarDays,
  ChartColumn,
  ClipboardList,
  FileCheck2,
  Handshake,
  House,
  Landmark,
  MessageCircle,
  MessagesSquare,
  Package,
  PackagePlus,
  Receipt,
  ScrollText,
  Settings,
  ShieldCheck,
  ShoppingBag,
  SlidersHorizontal,
  Stethoscope,
  UserCog,
  Users,
  Wallet,
  type LucideIcon,
} from "lucide-react";

export type ItemMenu = {
  /** Caminho da rota. Itens sem tela pronta abrem a página "Em construção". */
  para: string;
  rotulo: string;
  icone: LucideIcon;
  pronto?: boolean;
};

/**
 * `fixo`: grupo sempre aberto, com os itens de uso o dia todo. Os demais abrem e fecham no menu lateral
 * e, com o menu recolhido, viram um ícone (`icone`) que abre os itens num submenu.
 */
export type GrupoMenu = { titulo: string; icone: LucideIcon; fixo?: boolean; itens: ItemMenu[] };

// Mesma organização do mockup v4 (base-conhecimento/mockup/v4.html).
export const MENU: GrupoMenu[] = [
  {
    titulo: "Atendimento",
    icone: House,
    fixo: true,
    itens: [
      { para: "/", rotulo: "Início", icone: House, pronto: true },
      { para: "/agenda", rotulo: "Agenda", icone: CalendarDays, pronto: true },
      { para: "/conversas", rotulo: "Conversas", icone: MessagesSquare, pronto: true },
      { para: "/pacientes", rotulo: "Pacientes", icone: Users, pronto: true },
      { para: "/prontuario", rotulo: "Prontuário", icone: Stethoscope, pronto: true },
    ],
  },
  {
    titulo: "Vendas",
    icone: ShoppingBag,
    itens: [
      { para: "/cobrar", rotulo: "Cobrar", icone: Receipt, pronto: true },
      { para: "/caixa", rotulo: "Caixa do dia", icone: Wallet, pronto: true },
      { para: "/orcamentos", rotulo: "Interessados e orçamentos", icone: Handshake, pronto: true },
      { para: "/mensagens-automaticas", rotulo: "Mensagens automáticas", icone: BellRing, pronto: true },
    ],
  },
  {
    titulo: "Estoque",
    icone: Boxes,
    itens: [
      { para: "/estoque", rotulo: "Produtos e lotes", icone: Package, pronto: true },
      { para: "/entrada-nota", rotulo: "Entrada de nota", icone: PackagePlus, pronto: true },
    ],
  },
  {
    titulo: "Financeiro",
    icone: Banknote,
    itens: [
      { para: "/financeiro", rotulo: "Meu dinheiro", icone: Landmark, pronto: true },
      { para: "/contas-a-pagar", rotulo: "Contas a pagar", icone: ArrowUpFromLine, pronto: true },
      { para: "/contas-a-receber", rotulo: "Contas a receber", icone: ArrowDownToLine, pronto: true },
      { para: "/notas-fiscais", rotulo: "Notas fiscais", icone: FileCheck2, pronto: true },
      { para: "/relatorios", rotulo: "Relatórios", icone: ChartColumn, pronto: true },
    ],
  },
  {
    titulo: "Administração",
    icone: SlidersHorizontal,
    itens: [
      { para: "/cadastros", rotulo: "Cadastros da clínica", icone: ClipboardList, pronto: true },
      { para: "/usuarios", rotulo: "Usuários e permissões", icone: UserCog, pronto: true },
      { para: "/acessos", rotulo: "Registro de acessos", icone: ScrollText, pronto: true },
      { para: "/seguranca", rotulo: "Segurança e 2FA", icone: ShieldCheck, pronto: true },
      { para: "/empresas", rotulo: "Empresas e unidades", icone: Building2, pronto: true },
      { para: "/whatsapp", rotulo: "WhatsApp e horário", icone: MessageCircle, pronto: true },
      { para: "/configuracao", rotulo: "Configuração inicial", icone: Settings, pronto: true },
    ],
  },
];

/** Atalhos da barra inferior no celular; o resto fica em "Mais". */
export const ATALHOS_CELULAR = ["/", "/agenda", "/conversas", "/pacientes"];

export const TODOS_ITENS = MENU.flatMap((g) => g.itens);
export const SECOES_EM_CONSTRUCAO = TODOS_ITENS.filter((i) => !i.pronto);
